import { Component } from '@angular/core';
import { ChatbotService } from './_services/chatbot.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})

export class AppComponent {
  title = 'relay-ui';

  constructor(private chatbotService: ChatbotService) { } 

  ngOnInit() {
    this.chatbotService.loadChatbot(JSON.parse(localStorage.getItem('user')));
  } 

}
